<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="dialog-form">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4 class="modal-window__title">About {{ 'global.shortProductName' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div class="siklu-mat-dialog-body" matDialogContent>
        @if (systemInfo$ | async; as systemInfo) {
            <span>{{ 'global.productName' | translate }}</span>
            <span>Version {{ systemInfo.version }}</span>
            <span class="d-block">{{ systemInfo.copyright }}</span>
        }
    </div>
    <div matDialogActions></div>
</div>
